module.exports = __webpack_public_path__ + "img/wb_tm.22c9d779.jpg";